import React from 'react';
import './LoadingFallback.css';

export default function LoadingFallback() {
  return (
    <div className="loading-fallback" role="status" aria-label="Loading page">
      <div className="loading-fallback__ring">
        <div />
        <div />
        <div />
      </div>
      <p className="loading-fallback__label">Loading…</p>
    </div>
  );
}
